"use client";

import {
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Skeleton } from "@/components/ui/skeleton";

export default function ExpressInterestModalSkeleton() {
  return (
    <div className="space-y-4 p-6">
      <DialogHeader>
        <DialogTitle>
          <Skeleton className="h-7 w-72" />
        </DialogTitle>
        <DialogDescription className="sr-only">
          Express interest in principal connection
        </DialogDescription>
      </DialogHeader>

      <div className="flex items-center overflow-hidden rounded-lg border border-border bg-surface-subtle p-4">
        <div className="flex items-center gap-3 min-w-0 flex-1">
          <Skeleton className="h-12 w-12 rounded-full shrink-0" />
          <div className="space-y-2 min-w-0 flex-1">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-3 w-48" />
          </div>
        </div>
      </div>

      <div className="flex min-w-0 flex-col gap-4">
        <Skeleton className="h-24 w-full rounded-md" />
        <div className="flex items-center gap-3 rounded-lg bg-surface-subtle p-3">
          <Skeleton className="h-4 w-4 shrink-0 rounded" />
          <div className="space-y-2 flex-1">
            <Skeleton className="h-3 w-full" />
            <Skeleton className="h-3 w-4/5" />
          </div>
        </div>
        <div className="flex flex-row gap-2 justify-between">
          <Skeleton className="h-11 flex-1 rounded-lg" />
          <Skeleton className="h-11 flex-1 rounded-lg" />
        </div>
      </div>
    </div>
  );
}
